/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  ContentRef,
  CustomizationAnnouncement,
  CustomizationBackground,
  CustomizationCorners,
  CustomizationDefaultThemeMode,
  CustomizationDepth,
  CustomizationFavicon,
  CustomizationFooterGroup,
  CustomizationHeaderItem,
  CustomizationHeaderPreset,
  CustomizationIconsStyle,
  CustomizationLinksStyle,
  CustomizationLocale,
  CustomizationSearchStyle,
  CustomizationSidebarBackgroundStyle,
  CustomizationSidebarListStyle,
  CustomizationTheme,
  CustomizationThemedCodeTheme,
  CustomizationThemedColor,
  CustomizationThemedURL,
  CustomizationTint,
  EntityId,
  LocalizedString128,
  SiteCustomizationSettings,
  SiteCustomizationSettingsInput,
  SiteExternalLinksTarget,
  SiteSpaceCustomizationSettings,
  SiteTitle,
  SubscriptionNotice,
  URL,
} from "./data-contracts";

/**
 * @description Retrieves the full customization configuration for a site. Use this before making updates to read the current state, or to audit branding settings.
 * @tags site-customization
 * @name GetSiteCustomizationById
 * @summary Get the branding and visual customization settings for a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/customization
 * @secure
 */

// @ts-ignore
export const getSiteCustomizationById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /**
     * (Deprecated) Use the getRawCustomizationSettingsById internal endpoint.
     * @deprecated
     * @default false
     */
    unmasked?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteCustomizationSettings;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/customization",
  method: "get",
  streaming: false,
  tags: ["site-customization"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Replaces the full customization configuration for a site. This is a full replacement — unset fields revert to defaults. Use the GET endpoint first to read the current settings before making targeted changes.
 * @tags site-customization
 * @name UpdateSiteCustomizationById
 * @summary Update the branding and visual customization settings for a site
 * @request PUT:/orgs/{organizationId}/sites/{siteId}/customization
 * @secure
 */

// @ts-ignore
export const updateSiteCustomizationById: {
  route: string;
  method: "put";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: SiteCustomizationSettingsInput;
  RequestHeaders: {};
  ResponseBody: SiteCustomizationSettings & {
    /** A notice about the organization's subscription to relay to the user, such as how many days are left in their trial. It is returned by the operations whose features may require a paid plan once a trial ends. */
    subscriptionNotice?: SubscriptionNotice;
  };
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/customization",
  method: "put",
  streaming: false,
  tags: ["site-customization"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-customization, internal
 * @name GetSiteRawCustomizationById
 * @summary Get a site raw customization settings
 * @request GET:/orgs/{organizationId}/sites/{siteId}/customization/raw
 * @secure
 */

// @ts-ignore
export const getSiteRawCustomizationById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteCustomizationSettings;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/customization/raw",
  method: "get",
  streaming: false,
  tags: ["site-customization", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves the customization settings that override the site-level branding for a specific site space, such as a language variant or content version. Returns the effective settings with site-level defaults where no override is set. Use this before applying or removing overrides.
 * @tags site-customization
 * @name GetSiteSpaceCustomizationById
 * @summary Get the customization overrides for a site space
 * @request GET:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization
 * @secure
 */

// @ts-ignore
export const getSiteSpaceCustomizationById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site-space relationship */
    siteSpaceId: string;
  };
  RequestQuery: {
    /**
     * (Deprecated) Use the getRawCustomizationSettingsById internal endpoint.
     * @deprecated
     * @default false
     */
    unmasked?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteCustomizationSettings;
  ResponseStatusCode: 200 | 400;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization",
  method: "get",
  streaming: false,
  tags: ["site-customization"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Applies customization overrides to a specific site space, such as a language variant or content version, that take precedence over the site-level settings. Only provided fields are overridden; set a field to null to clear its override and fall back to the site-level value.
 * @tags site-customization
 * @name OverrideSiteSpaceCustomizationById
 * @summary Override branding and customization settings for a specific site space
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization
 * @secure
 */

// @ts-ignore
export const overrideSiteSpaceCustomizationById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site-space relationship */
    siteSpaceId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Title to use for the published site variant. If not defined, the title will not be changed. If set to null, the title will be unset and will fallback to the content title. */
    title?: SiteTitle | null;
    /** Localized titles for the site variant, keyed by locale. If not defined, the localized title will not be changed. If set to null, all localized titles will be removed. */
    localizedTitle?: LocalizedString128 | null;
    styling?: {
      /** The site theme. Set to null to reset the override. */
      theme?: CustomizationTheme | null;
      /** The primary color used for links and UI text. Set to null to reset the override. */
      primaryColor?: CustomizationThemedColor | null;
      /** The secondary brand color used for secondary buttons and content colored with `$secondary`. Set to null to reset the override. */
      secondaryColor?: CustomizationThemedColor | null;
      /** Used for informational messages and neutral alerts. Set to null to reset the override. */
      infoColor?: CustomizationThemedColor | null;
      /** Used for showing positive actions or achievements. Set to null to reset the override. */
      successColor?: CustomizationThemedColor | null;
      /** Used for showing important information or non-critical warnings. Set to null to reset the override. */
      warningColor?: CustomizationThemedColor | null;
      /** Used for destructive actions or raising attention to critical information. Set to null to reset the override. */
      dangerColor?: CustomizationThemedColor | null;
      /** The tint will color the site’s UI beyond links and buttons, such as header, sidebar and background. By default, the tint colour is the same as your Primary colour, but you can set a custom one too. Set to false to remove the tint from this site space, or to null to reset the override. */
      tint?: CustomizationTint | false | null;
      /** The style of the corners to use. Set to null to reset the override. */
      corners?: CustomizationCorners | null;
      /** The depth of elements on the site. Set to null to reset the override. */
      depth?: CustomizationDepth | null;
      /** The style for links to use. Set to null to reset the override. */
      links?: CustomizationLinksStyle | null;
      /** The icons style to use for the content. Set to null to reset the override. */
      icons?: CustomizationIconsStyle | null;
      /** Various styles for the sidebar. Each can be Set to null to reset the override. */
      sidebar?: {
        background?: CustomizationSidebarBackgroundStyle | null;
        list?: CustomizationSidebarListStyle | null;
      };
      /** Styling for the search button at the top of the site. */
      search?: CustomizationSearchStyle | null;
      /** The style of background to use. Set to null to reset the override. */
      background?: CustomizationBackground | null;
      /** The code theme to use. Set to null to reset the override. */
      codeTheme?: {
        default?: CustomizationThemedCodeTheme | null;
        openapi?: CustomizationThemedCodeTheme | null;
      };
    };
    /** @deprecated */
    internationalization?: {
      /** The locale to use for the non-custom elements of the UI. Set to null to reset the override. */
      locale: CustomizationLocale | null;
    };
    /** The favicon to use. Set to null to reset the override. */
    favicon?: CustomizationFavicon | null;
    announcement?: CustomizationAnnouncement;
    header?: {
      /** The theme preset to use. Set to null to reset the override. */
      preset?: CustomizationHeaderPreset | null;
      /** The header logo to use. Set to null to reset the override. */
      logo?: CustomizationThemedURL | null;
      /** The destination to open when visitors click the site title/logo in the header. Set to null to reset the override. */
      primaryLink?: ContentRef | null;
      /** The background color used in the header. Set to null to reset the override. */
      backgroundColor?: CustomizationThemedColor | null;
      /** The color used by the links in the header. Set to null to reset the override. */
      linkColor?: CustomizationThemedColor | null;
      /** The links that are displayed in the header. Set to null to reset the override. */
      links?: CustomizationHeaderItem[] | null;
    };
    footer?: {
      /** The logo displayed in the footer. Set to null to reset the override. */
      logo?: CustomizationThemedURL | null;
      /** The links groups that are displayed in the footer. Set to null to reset the override. */
      groups?: CustomizationFooterGroup[] | null;
      /**
       * The copyright text that is displayed in the footer. Set to null to reset the override.
       * @maxLength 512
       */
      copyright?: string | null;
    };
    themes?: {
      /** The theme mode default value. Set to null to reset the override. */
      default?: CustomizationDefaultThemeMode | null;
      /** Should the reader be able to switch between dark and light mode. Set to null to reset the override. */
      toggeable?: boolean | null;
    };
    feedback?: {
      /** If true, feedback gathering is enabled. Set to null to reset the override. */
      enabled: boolean | null;
    };
    externalLinks?: {
      /** How external links should open. Set to null to reset the override. */
      target: SiteExternalLinksTarget | null;
    };
    pagination?: {
      /** Whether the pagination navigation should be displayed on pages. Set to null to reset the override. */
      enabled: boolean | null;
    };
    trademark?: {
      /** Whether the GitBook trademark ("Powered by GitBook") should be visible. Set to null to reset the override. */
      enabled: boolean | null;
    };
    privacyPolicy?: {
      /** The custom link to the privacy policy. Set to null to reset the override. */
      url?: URL | null;
    };
    socialPreview?: {
      /** The URL for the social preview image. Set to null to reset the override. */
      url?: URL | null;
    };
  };
  RequestHeaders: {};
  ResponseBody: SiteCustomizationSettings;
  ResponseStatusCode: 200 | 400;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization",
  method: "patch",
  streaming: false,
  tags: ["site-customization"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-customization
 * @name DeleteSiteSpaceCustomizationById
 * @summary Delete a site space customization settings
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization
 * @secure
 */

// @ts-ignore
export const deleteSiteSpaceCustomizationById: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site-space relationship */
    siteSpaceId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205 | 400;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization",
  method: "delete",
  streaming: false,
  tags: ["site-customization"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-customization, internal
 * @name GetSiteSpaceRawCustomizationById
 * @summary Get a site space raw customization settings
 * @request GET:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization/raw
 * @secure
 */

// @ts-ignore
export const getSiteSpaceRawCustomizationById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site-space relationship */
    siteSpaceId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteSpaceCustomizationSettings;
  ResponseStatusCode: 200 | 400;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization/raw",
  method: "get",
  streaming: false,
  tags: ["site-customization", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
